import { render, staticRenderFns } from "./nav-modular.vue?vue&type=template&id=21398ae5&scoped=true&"
import script from "./nav-modular.vue?vue&type=script&lang=js&"
export * from "./nav-modular.vue?vue&type=script&lang=js&"
import style0 from "./nav-modular.vue?vue&type=style&index=0&id=21398ae5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21398ae5",
  null
  
)

export default component.exports